import React, { } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {convertSecondsToHourMinutesFormat, convertSecondsToMinutesSecondsFormat} from "../../../../common/Util";
import Grid from "@material-ui/core/Grid/Grid";
import KpiGrid from "./KpiGrid";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Typography from "@material-ui/core/Typography";
import MetaChartGrid from "./MetaChartGrid";


const useStyles = makeStyles(theme => ({

    mainGrid: {
      margin: 0,
      display: 'flex',
        height: '80mm',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      alignItems: 'stretch',
      alignContent: 'stretch',
      border: 1,
      borderStyle: 'solid',
      borderColor: 'black',
      borderRadius: '5px'
    },
    grid1Linha: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        alignItems: 'stretch',
        alignContent: 'stretch',
        border: 1,
        // borderStyle: 'solid',
        borderColor: 'black',
        borderRadius: '5px'
    },
    gridColuna: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        alignItems: 'stretch',
        alignContent: 'stretch',
        border: 1,
        // borderStyle: 'solid',
        borderColor: 'black',
        borderRadius: '5px'
    },
    marginAuto:{
      flexGrow: 1,
      flexShrink: 1,
      margin: '8px',
      border: '3px',
      borderColor: 'yellow',

  }
}));

const renderLoadingScreen = () => {
    const { classes } = this.props;
    return (
        <React.Fragment>
            {this.renderSearchComponent()}
            <div align="center">
                <CircularProgress className={classes.progress} />
            </div>
        </React.Fragment>
    )
}

export default function RaspaKPIs(prop) {
  const {filter, raspaReportData, isLoading} = prop;

  const classes = useStyles();


  //
  const e = filter.estabelecimentos.find( e => e.id === filter.estabelecimentoId);
  const cHD = e? e.cargaHorariaDia : 8;

  // if (series) {
  //   cH = commercialHoursInInterval(filter.periodMin, filter.periodMax, cHD);
  // }



  if (isLoading) {return renderLoadingScreen()}


  // Garantir que valores do MySQL SUM() sejam números (mysql2 retorna DECIMAL como string)
  const tempoCiclo = Number(raspaReportData.periodo.totaisGerais.tempoCiclo);
  const tempoEsperaOper = Number(raspaReportData.periodo.totaisGerais.tempoEsperaOper);
  const numCiclos = Number(raspaReportData.periodo.totaisGerais.numCiclos);
  const tempoCicloBase = Number(raspaReportData.periodoComparacao.totaisGerais.tempoCiclo);
  const tempoEsperaOperBase = Number(raspaReportData.periodoComparacao.totaisGerais.tempoEsperaOper);

  const  avgTempoPorCiclo = convertSecondsToMinutesSecondsFormat(
                   Math.round((tempoCiclo - tempoEsperaOper) / numCiclos));

  const  avgTempoEsperaOperador = Math.round(tempoEsperaOper / numCiclos);

  const avgTempoTotal =  convertSecondsToMinutesSecondsFormat(
      Math.round(tempoCiclo / numCiclos));

  const percUtilizacao = Math.round((tempoCiclo + tempoEsperaOper) / 60 / 60 * 10) / 10;
  const percUtilizacaoBase = Math.round((tempoCicloBase + tempoEsperaOperBase) / 60 / 60 * 10) / 10;

  const horasDeMaq = tempoCiclo + tempoEsperaOper;
    // Total de dias trabalhados x 8horas dia x 60min x 60seg
  const totalDiasProdPeriodo = raspaReportData.periodo.totaisPorData.length * 8 * 60 * 60;
  const percUtilPeriodo =   Math.round(horasDeMaq / totalDiasProdPeriodo * 1000) / 10 ;

    const horasDeMaqBase = tempoCicloBase + tempoEsperaOperBase;
    // Total de dias trabalhados x 8horas dia x 60min x 60seg
    const totalDiasProdPeriodoBase = raspaReportData.periodo.totaisPorData.length * 8 * 60 * 60;
    const percUtilPeriodoBase =   Math.round(horasDeMaqBase / totalDiasProdPeriodoBase * 1000) / 10 ;


    return (
    <Grid container xs={12} className={classes.mainGrid}>
        <Grid item id={'titulo kpi'} className={classes.marginAuto} sm={12} md={12}>
            <Typography>PRINCIPAIS INDICADORES</Typography>
        </Grid>

        <Grid item id={'RaspaKpi-1aLinha'} className={classes.grid1Linha} >
            <Grid className={classes.gridColuna} style={{ width: '20%', alignItems:'center'}}>
               <MetaChartGrid titulo={'O.S.'} valor={raspaReportData.periodo.numOSDistintas.oSDistintasEmRaspValidas} unidadeValor={''} meta={100} width={150} height={150}/>
            </Grid>
            <Grid className={classes.gridColuna} style={{ width: '80%'}}>
                <KpiGrid
                    valor={raspaReportData.periodo.totaisGerais.numCiclos}
                    valorBase={raspaReportData.periodoComparacao.totaisGerais.numCiclos}
                    titulo={<span>RASPAGENS</span>}
                    descricao={''}
                    unidadeValor=""
                />
                <KpiGrid
                    valor={raspaReportData.periodo.numOSDistintas.oSDistintasEmRaspValidas}
                    valorBase={raspaReportData.periodoComparacao.numOSDistintas.oSDistintasEmRaspValidas}
                    titulo={<span>ORDENS DE SERVIÇO</span>}
                    descricao={''}
                    unidadeValor=""
                />
                <KpiGrid
                    valor={percUtilPeriodo}
                    valorBase={percUtilPeriodoBase}
                    titulo={<span>UTILIZAÇÃO.</span>}
                    descricao={''}
                    unidadeValor="%"
                />

                <KpiGrid
                    valor={avgTempoPorCiclo}
                    titulo={<span>TEMPO DE MAQ.</span>}
                    descricao={''}
                    unidadeValor='"'
                />
                <KpiGrid
                    valor={avgTempoEsperaOperador}
                    titulo={<span>ESPERA OPERADOR</span>}
                    descricao={''}
                    unidadeValor='"'
                />
                <KpiGrid
                    valor={avgTempoTotal}
                    titulo={<span>TEMPO MEDIO TOTAL</span>}
                    descricao={''}
                    unidadeValor='"'
                />
            </Grid>


        </Grid>



        {/*<Grid item className={classNames(classes.marginAuto)}>*/}
        {/*<KpiGrid*/}
        {/*    className={classes.marginAuto}*/}
        {/*    mainvalue={<span>{checkNull(percent,'--')}%</span>}*/}
        {/*  title={<span>UTILIZAÇÃO</span>}*/}
        {/*  description={<span>{perioddata[0]}h em {cH} horas disponíveis.</span>}*/}
        {/*    unit="percentual"*/}
        {/*/>*/}
        {/*</Grid>*/}
        {/*<Grid item className={classNames(classes.marginAuto)}>*/}
        {/*<KpiGrid*/}
        {/*    className={classes.marginAuto}*/}
        {/*  mainvalue={checkNull(dataMaq+'', '--')}*/}
        {/*  title='TEMPO MÉDIO TOTAL'*/}
        {/*  unit='minutos'*/}
        {/*  description={<span>tempo médio total por raspagem</span>}*/}

        {/*/>*/}
        {/*</Grid>*/}
        {/*<Grid item className={classNames(classes.marginAuto)}>*/}
        {/*<KpiGrid*/}
        {/*    className={classes.marginAuto}*/}
        {/*  mainvalue={checkNull(dataOper+'','--')}*/}
        {/*  title={<span>ESPERA OPERADOR</span>}*/}
        {/*  description={<span>espera incluida no tempo total.</span>}*/}
        {/*  unit={<span>segundos</span>}*/}
        {/*/>*/}
        {/*</Grid>*/}

    </Grid>
  )
}
;
